import React, { Component } from 'react';
import { Table,Button,Input, Row, Col,Select,Menu,Icon,Modal,Form,DatePicker,message,Radio, Breadcrumb} from 'antd';
import {action} from './'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {getFilterColumns} from './columns'
import axios from 'axios';
import $ from '$';
import API from '../../../../API/api';
import CreateTask from "./creat_task/view";

const Search = Input.Search;
const Option = Select.Option;
const confirm = Modal.confirm;


const STAGE_MAP_REVERES = [
    'pre_assign',
    'signing',
    'pre_check',
    'checking',
    'rework',
    'check_pass',
    'online_ing',
    'online_success',
    'online_fail',
]

class MissionList extends Component{
    state={
        advanceSearch:false,

        search:'',
        page:1,
        pagesize:20,
        searchType:'0',
        search_evaluating_user:'',
        search_evaluating_check:'',//高级搜索时选中的审核人

        taskList:[],
        visible:false,
        totalWidth:1002,
        selectedRowKeys: [], // Check here to configure the default column

        assignEvaluatingUser:false,//分配标记员
        assignEvaluatingCheck:false,

        evaluatingUserList:'',//分配标记员
        evaluatingUser:'',
        evaluatingCheckList:'',//分配编写审核员
        evaluatingCheck:'',//分配编写审核员


        exportStatic:false,//导出
        exportStartTime:'',
        exportEndTime:'',
        evaluatingSubmitNotAllDo:false,//评测任务提交时为完成所有题目时提示的modal
    }
    columnsToDisplay={
        pre_assign:[],
        signing:[],
        pre_check:[],
        checking:[],
        rework:[],

        check_pass:[],
        online_ing:[],
        online_success:[],
        online_fail:[],
    }

    inited = false

    componentWillUpdate(newProps){
        if((this.props.user!=newProps.user)||(newProps.user&&!this.inited)) {
            this.inited = true

            let role_evaluation = newProps.user.role_evaluation
            if (!role_evaluation) {
                return;
            }
            if(role_evaluation){//'高级搜索权限'
                if(this.state.evaluatingUserList===''){
                    axios.post(API.EVALUATION_USER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({evaluatingUserList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }

                if(this.state.evaluatingCheckList===''){
                    axios.post(API.EVALUATION_CHECK_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({evaluatingCheckList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }

            }

            //任务的9个阶段显示哪几个

            this.columnsToDisplay = {
                pre_assign: getFilterColumns(role_evaluation, 'pre_assign'),
                signing: getFilterColumns(role_evaluation, 'signing'),
                pre_check: getFilterColumns(role_evaluation, 'pre_check'),
                checking: getFilterColumns(role_evaluation, 'checking'),
                rework: getFilterColumns(role_evaluation, 'rework'),

                check_pass: getFilterColumns(role_evaluation, 'check_pass'),
                online_ing: getFilterColumns(role_evaluation, 'online_ing'),
                online_success: getFilterColumns(role_evaluation, 'online_success'),
                online_fail: getFilterColumns(role_evaluation, 'online_fail'),
            }

            this.state.columns = this.columnsToDisplay['pre_assign']
            //设置选中的第一列
            let col = role_evaluation.columns
            let current = 'online_fail'
            if(col.length){
                for(let i=col.length-1;i>=0;i--){
                    col[i].forEach(d=>{
                        if(d>0){
                            current =STAGE_MAP_REVERES[i]
                        }
                    })
                }
            }
            this.state.columns = this.columnsToDisplay[current]
            this.props.setCurrent(current)
            this.getTastList(current)


        }
    }
    componentDidMount(){
        this.forceUpdate()

    }

    onEmpty = ()=>{
        this.setState({
            search:'',
            search_evaluating_check:'',
            search_evaluating_user:''
        })

    }
    getTastList = (stage=this.props.current,callback)=>{
        setTimeout(()=>{
            let data = {
                page:this.state.page,
                pagesize:this.state.pagesize,
                search:this.state.search,
                stage_type:stage,
                sign_user:this.state.search_evaluating_user,
                check_user:this.state.search_evaluating_check
            }
            axios.post(API.EVALUATION_TASK_LIST, data).then((res)=>{
                res = res.data;
                if (res.code === 0) {
                    this.setState({taskList:res.data.list||[],total:res.data.total})
                    callback&&callback()
                }else{
                    message.error(res.message);
                }
            },()=>{message.error("网络错误！")})
        },0)


    }
    showDeleteConfirm = () => {
        const ids = this.state.selectedRowKeys;
        const me = this;
        confirm({
            title: '确定删除任务？',
            content: '删除任务后不可恢复，确定删除吗？',
            onOk() {
                return new Promise((resolve, reject) => {
                    axios.post(API.EVALUATION_TASK_DEL, {task_id:ids}).then((res)=>{
                        res = res.data;
                        if (res.code === 0) {
                            message.success("删除成功！");
                            resolve();
                            me.onRefreshList();
                        }else{
                            message.error(res.message);
                            reject();
                        }
                    },()=>{message.error("删除失败！")})
                })
            },
            onCancel() {},
        });
    }
    onShow = () => {//创建任务修改任务
        this.setState({visible:true,taskId:''})

    }

    onCancel = () => {
        this.setState({visible:false})
    }
    handleClick = (e) => {
        this.state.selectedRowKeys = [];
        this.props.setCurrent(e.key)
        this.getTastList(e.key,()=>{
            this.setState({
                columns:this.columnsToDisplay[e.key],
            });
        })
    }
    onSelectChange = (selectedRowKeys,dsd) => {//表格行的选则框
        this.setState({ selectedRowKeys:selectedRowKeys });
    }
    onRefreshList = () => {
        this.state.selectedRowKeys = [];
        this.getTastList()
    }
    onPageChange = (val) => {
        this.setState({page:val})
        this.onRefreshList()
        document.querySelector('.questionListScroll').scrollTop=0
    }
    onSearch = () => {
        this.setState({page:1})
        this.state.page = 1
        this.onRefreshList()
    }


    //分配标记员 打开
    assignEvaluatingUser =()=>{
        this.setState({assignEvaluatingUser:true})
        if(this.state.evaluatingUserList===''){
            axios.post(API.EVALUATION_USER_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({evaluatingUserList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }
    // 分配标记员
    onAssignEvaluatingUser = () => {
        if(this.state.evaluatingUser){
            axios.post(API.EVALUATION_TASK_ASSIGN_USER, {task_id:this.state.selectedRowKeys,user_id:this.state.evaluatingUser}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({evaluatingUser:'',assignEvaluatingUser:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择标记审核员！")
        }
    }

    //打标记提交
    onEvaluatingSubmit=()=>{
        let task_ids = this.state.selectedRowKeys
        let allDo = false
        task_ids.forEach((d)=>{
            this.state.taskList.forEach((task)=>{
                if(d==task.task_id){
                    if(task.question_evaluatingUser<task.question_count){
                        allDo = true
                    }
                }
            })
        })

        if(allDo){
            this.setState({evaluatingSubmitNotAllDo:true})
        }else{
            axios.post(API.EVALUATION_TASK_SUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success("提交成功！")
                    this.onRefreshList();
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }

    }
    evaluationSubmitNotAllDoOnOk=()=>{
        this.setState({evaluatingSubmitNotAllDo:false})
        axios.post(API.EVALUATION_TASK_SUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})


    }
    //返工时的图片任务提交
    onEvaluatingReSubmit=()=>{
        axios.post(API.EVALUATION_TASK_REWORK_SUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //分配审核员
    assignEvaluatingCheck =()=>{
        this.setState({assignEvaluatingCheck:true})
        if(this.state.evaluatingCheckList===''){
            axios.post(API.EVALUATION_CHECK_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({evaluatingCheckList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }

    // 分配审核员
    onAssignEvaluatingCheck = () => {
        if(this.state.evaluatingCheck){
            axios.post(API.EVALUATION_TASK_ASSIGN_USER_CHECK, {task_id:this.state.selectedRowKeys,user_id:this.state.evaluatingCheck}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({evaluatingCheck:'',assignEvaluatingCheck:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择标记审核员！")
        }
    }

    //标记审核提交
    onEvaluatingCheckSubmit=()=>{
        axios.post(API.EVALUATION_TASK_CHECK_PASS, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //标记审核返工
    onEvaluatingCheckRework=()=>{
        if(this.state.mark.trim().length<1){return message.error('请填写返工原因')}
        axios.post(API.EVALUATION_TASK_REWORK, {task_id:this.state.selectedRowKeys,mark:this.state.mark}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("返工成功！")
                this.setState({reworkModal: false})
                this.onRefreshList();
            }else{
                message.error(res.message)
                this.setState({reworkModal: false})
            }
        },()=>{message.error("网络错误！")})
    }
    
    //入库操作
    onEvaluatingOnLine=()=>{
        axios.post(API.EVALUATION_TASK_ONLINE, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("入库操作提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    onStartChange = (value) => {
        this.setState({exportStartTime:value});
    }

    onEndChange = (value) => {
        this.setState({exportEndTime:value});
    }
    //任务统计
    onGetExoprtStatic = ()=>{
        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.EVALUATING_TASK_EXPORT);
        var input1 = $('<input>');
        input1.attr('type', 'hidden');
        input1.attr('name', 'start_time');
        if(this.state.exportStartTime){
            input1.attr('value', this.state.exportStartTime.format('YYYY-MM-DD'));
        }
        var input2 = $('<input>');
        input2.attr('type', 'hidden');
        input2.attr('name', 'end_time');
        if(this.state.exportEndTime){
            input2.attr('value', this.state.exportEndTime.format('YYYY-MM-DD'));
        }
        $('body').append(form);  //将表单放置在web中
        form.append(input1);   //将查询参数控件提交到表单上
        form.append(input2);
        form.submit();
        this.setState({exportStatic:false})
    }

    render(){
        let role_evaluation = this.props.user.role_evaluation
        if(!role_evaluation){return null}
        const data = [];
        this.state.taskList && this.state.taskList.forEach((val)=>{
            val.key = val.task_id
            data.push(val);
        })
        const {selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        let canDelect = true
        let canOnline = true
        selectedRowKeys.forEach((id)=>{
            data.forEach((item)=>{
                if(item.task_id == id){
                    if(!item.is_test=='0'){
                        canDelect = false
                    }else{
                        canOnline = false
                    }
                }
            })
        })
        const getOptionButton = ()=>{
            let result = '';
            switch (this.props.current){
                case 'pre_assign':
                    result =<Col span={12}>

                        {
                            role_evaluation.buttons.taskAdd===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" onClick={this.onShow}>创建任务</Button>

                        }
                        {this.state.visible && <CreateTask subject={this.props.user.subject} onCancel={this.onCancel} visible={this.state.visible} taskId={this.state.taskId} refresh={()=>{this.onRefreshList(1)}}/>}

                        {
                            role_evaluation.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }


                        {
                            role_evaluation.buttons.taskAssign===1 &&
                            // 分配录入员： 任务管理权限、组管理权限 可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignEvaluatingUser}>分配标记员</Button>
                        }

                        <Modal title="分配标记员" visible={this.state.assignEvaluatingUser} onOk={this.onAssignEvaluatingUser} onCancel={()=>this.setState({assignEvaluatingUser:false})}>
                            <span style={{marginLeft:30}}>分配标记员：</span>
                            <Select
                                showSearch
                                placeholder="请选择标记员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({evaluatingUser:val})}}
                                value={this.state.evaluatingUser}
                            >
                                {
                                    this.state.evaluatingUserList&&this.state.evaluatingUserList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                    </Col>
                    break;
                case 'signing':
                    result =<Col span={12}>
                        {
                            role_evaluation.buttons.sign===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onEvaluatingSubmit}>提&nbsp;&nbsp;交</Button>
                        }

                        {
                            role_evaluation.buttons.taskAssign===1&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignEvaluatingUser}>分配标记员</Button>
                        }

                        <Modal title="分配标记员" visible={this.state.assignEvaluatingUser} onOk={this.onAssignEvaluatingUser} onCancel={()=>this.setState({assignEvaluatingUser:false})}>
                            <span style={{marginLeft:30}}>分配标记员：</span>
                            <Select
                                showSearch
                                placeholder="请选择标记员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({evaluatingUser:val})}}
                                value={this.state.evaluatingUser}
                            >
                                {
                                    this.state.evaluatingUserList&&this.state.evaluatingUserList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                        {
                            role_evaluation.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected&&!canDelect} onClick={this.showDeleteConfirm}>删除测试任务</Button>

                        }
                    </Col>
                    break;
                case 'pre_check':
                    result =<Col span={12}>
                        {
                            role_evaluation.buttons.taskAssignCheck===1&&  //
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignEvaluatingCheck}>分配标记审核人</Button>
                        }

                        <Modal title="待标记审核" visible={this.state.assignEvaluatingCheck} onOk={this.onAssignEvaluatingCheck} onCancel={()=>this.setState({assignEvaluatingCheck:false})}>
                            <span style={{marginLeft:30}}>分配标记员：</span>
                            <Select
                                showSearch
                                placeholder="请选择审核员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({evaluatingCheck:val})}}
                                value={this.state.evaluatingCheck}
                            >
                                {
                                    this.state.evaluatingCheckList&&this.state.evaluatingCheckList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>

                        {
                            role_evaluation.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected&&!canDelect} onClick={this.showDeleteConfirm}>删除测试任务</Button>

                        }
                    </Col>
                    break;
                case 'checking':
                    result =<Col span={12}>

                        {
                            role_evaluation.buttons.checkPass===1&&//标记中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onEvaluatingCheckSubmit}>通&nbsp;&nbsp;过</Button>
                        }
                        {
                            role_evaluation.buttons.checkRework===1&&//标记中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={()=>{this.setState({mark:'',reworkModal:true})}}>返&nbsp;&nbsp;工</Button>
                        }
                        <Modal title="返工原因" visible={this.state.reworkModal} onOk={()=>{this.onEvaluatingCheckRework()}}
                               onCancel={() => this.setState({reworkModal: false})}>
                            <span style={{color:'red'}}>*</span><Input  style={{margin: '10px 0'}} onChange={(e)=>{if(e.target.value.length<=20){this.setState({mark:e.target.value})}}}/>

                        </Modal>
                        {
                            role_evaluation.buttons.taskAssignCheck===1&&  //
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignEvaluatingCheck}>分配标记审核人</Button>
                        }
                        <Modal title="标记审核" visible={this.state.assignEvaluatingCheck} onOk={this.onAssignEvaluatingCheck} onCancel={()=>this.setState({assignEvaluatingCheck:false})}>
                            <span style={{marginLeft:30}}>分配标记员：</span>
                            <Select
                                showSearch
                                placeholder="请选择审核员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({evaluatingCheck:val})}}
                                value={this.state.evaluatingCheck}
                            >
                                {
                                    this.state.evaluatingCheckList&&this.state.evaluatingCheckList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                        {
                            role_evaluation.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected&&!canDelect} onClick={this.showDeleteConfirm}>删除测试任务</Button>

                        }
                    </Col>
                    break;

                case 'rework':
                    result =<Col span={12}>
                        {
                            role_evaluation.buttons.reworkSign===1&&//标记中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onEvaluatingReSubmit}>提&nbsp;&nbsp;交</Button>
                        }

                        {
                            role_evaluation.buttons.taskAssign===1&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignEvaluatingUser}>分配标记员</Button>
                        }

                        <Modal title="分配标记员" visible={this.state.assignEvaluatingUser} onOk={this.onAssignEvaluatingUser} onCancel={()=>this.setState({assignEvaluatingUser:false})}>
                            <span style={{marginLeft:30}}>分配标记员：</span>
                            <Select
                                showSearch
                                placeholder="请选择标记员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({evaluatingUser:val})}}
                                value={this.state.evaluatingUser}
                            >
                                {
                                    this.state.evaluatingUserList&&this.state.evaluatingUserList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                        {
                            role_evaluation.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected&&!canDelect} onClick={this.showDeleteConfirm}>删除测试任务</Button>

                        }

                    </Col>
                    break;
                case 'check_pass':
                    result =<Col span={12}>
                        {
                            role_evaluation.buttons.taskOnline===1&&//标记中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected&&canOnline} onClick={this.onEvaluatingOnLine}>入&nbsp;&nbsp;库</Button>
                        }
                        {
                            role_evaluation.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected&&!canDelect} onClick={this.showDeleteConfirm}>删除测试任务</Button>

                        }
                    </Col>
                    break;
                case 'online_ing':
                    result =<Col span={12}>

                    </Col>
                    break;
                case 'online_success':
                    result =<Col span={12}>

                    </Col>
                    break;
                case 'online_fail':
                    result =<Col span={12}>
                        {
                            role_evaluation.buttons.taskOnline===1&&//标记中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected&&canOnline} onClick={this.onEvaluatingOnLine}>入&nbsp;&nbsp;库</Button>
                        }
                    </Col>
                    break;
                default:
                    result =<Col span={12} style={this.state.advanceSearch?{marginTop:66}:{}}></Col>
                    break;
            }
            return result

        }
        ///导出时间
        let disabledEndDate = (endValue) => {
            const startValue = this.state.exportStartTime;
            if (!endValue || !startValue) {
                return false;
            }
            return endValue.valueOf() <= startValue.valueOf();
        }
        let disabledStartDate = (current) => {
            return current && current.valueOf() >= Date.now();
        }
        let width = 0;
        for(let key in this.columnsToDisplay[this.props.current]){
            width += this.columnsToDisplay[this.props.current][key].width;
        }
        this.state.totalWidth=width+90
        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>题目管理</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>评测&精题任务</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={24}>
                        {
                                <div className={'searchHead'}>
                                    <Row style={{marginBottom:5}}>

                                        <div style={{fontSize: 14,marginLeft:'20px',display:'inline-block'}}>
                                            <label style={{width:'80px',display:'inline-block'}} htmlFor="search_evaluating">标记员：</label>
                                            <Select
                                                value={this.state.search_evaluating_user}
                                                style={{ width: 120 }}
                                                onChange={(val)=>{this.setState({search_evaluating_user:val})}}
                                                showSearch
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                id="search_evaluating">
                                                <Option key={-1} value={'-1'}>所有</Option>
                                                {
                                                    this.state.evaluatingUserList&&this.state.evaluatingUserList.map(item =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>
                                        <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                            <label style={{width:'80px',display:'inline-block'}} htmlFor="search_evaluating_check">审核人：</label>
                                            <Select value={this.state.search_evaluating_check}
                                                    style={{ width: 120 }}
                                                    showSearch
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    onChange={(val)=>{this.setState({search_evaluating_check:val})}}
                                                    id="search_evaluating_check">
                                                <Option key={-1} value={'-1'}>所有</Option>
                                                {
                                                    this.state.evaluatingCheckList&&this.state.evaluatingCheckList.map(item =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>
                                        <Search
                                            placeholder="输入关键字"
                                            style={{ width: 220,marginLeft:20}}
                                            onSearch={this.onSearch}
                                            onChange={(e)=>this.setState({search:e.target.value})}
                                            value={this.state.search}
                                        />
                                        <Button style={{fontSize: 12,marginLeft:'20px'}} type="primary" onClick={this.onSearch}>搜索</Button>
                                        <Button style={{fontSize: 12,marginLeft:'20px'}} type="danger" onClick={this.onEmpty}>清空</Button>
                                    </Row>
                                </div>
                        }
                    </Col>
                </Row>
                <Row style={{marginTop:10,maxWidth:1280}}>
                    <Col span={24}>
                        <div style={{fontSize:12}}>
                            <Menu
                                onClick={this.handleClick}
                                selectedKeys={[this.props.current]}
                                mode="horizontal"
                                style={{marginBottom:5,backgroundColor:'#f7f7f7',padding:'0 15px',borderRadius:6}}
                            >
                                {
                                    role_evaluation.columns[0].some(d=>d>0)&&
                                    <Menu.Item key="pre_assign">待分配</Menu.Item>
                                }
                                {
                                    role_evaluation.columns[1].some(d=>d>0)&&
                                    <Menu.Item key="signing">标记中</Menu.Item>
                                }
                                {
                                    role_evaluation.columns[2].some(d=>d>0)&&
                                    <Menu.Item key="pre_check">待审核</Menu.Item>
                                }
                                {
                                    role_evaluation.columns[3].some(d=>d>0)&&
                                    <Menu.Item key="checking">审核中</Menu.Item>
                                }
                                {
                                    role_evaluation.columns[4].some(d=>d>0)&&
                                    <Menu.Item key="rework">返工</Menu.Item>
                                }

                                {
                                    role_evaluation.columns[5].some(d=>d>0)&&
                                    <Menu.Item key="check_pass">审核完成</Menu.Item>
                                }
                                {
                                    role_evaluation.columns[6].some(d=>d>0)&&
                                    <Menu.Item key="online_ing">入库中</Menu.Item>
                                }
                                {
                                    role_evaluation.columns[7].some(d=>d>0)&&
                                    <Menu.Item key="online_success">入库成功</Menu.Item>
                                }
                                {
                                    role_evaluation.columns[8].some(d=>d>0)&&
                                    <Menu.Item key="online_fail">入库失败</Menu.Item>
                                }


                            </Menu>
                        </div>
                    </Col>

                </Row>
                <Row style={{marginBottom:5,maxWidth:1280}}>
                    {
                        getOptionButton()
                    }
                    <Col span={12}>
                        <div style={{fontSize:12,float:'right'}}>

                            {
                                role_evaluation.buttons.taskStatics===1 &&//导出
                                <Button style={{fontSize: 12}} type="primary" onClick={()=>this.setState({exportStatic:true})}>统计表下载</Button>
                            }
                            <Modal title="任务结算导出" visible={this.state.exportStatic} onOk={this.onGetExoprtStatic} onCancel={()=>this.setState({exportStatic:false})}>
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'开始时间'}
                                    style={{marginRight:20}}
                                    onChange={this.onStartChange}
                                    disabledDate={disabledStartDate}
                                />
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'结束时间'}
                                    onChange={this.onEndChange}
                                    disabledDate={disabledEndDate}
                                />
                            </Modal>
                        </div>
                    </Col>
                </Row>

                <Modal title="提交" visible={this.state.evaluatingSubmitNotAllDo} onOk={this.evaluationSubmitNotAllDoOnOk} onCancel={()=>this.setState({evaluatingSubmitNotAllDo:false})}>
                    <span style={{marginLeft:30}}>未完成所有题目，是否提交？</span>

                </Modal>
                <Row style={{maxWidth:this.state.totalWidth,minWidth:'100%'}}>
                    <Table rowSelection={rowSelection}
                           columns={this.state.columns}
                           dataSource={data}
                           rowClassName={(record)=>record.is_test==='1'?'testTask':''}
                           pagination={{showQuickJumper:true,current:this.state.page,pageSize:+this.state.pagesize,total:this.state.total,onChange:this.onPageChange }}
                           loading={this.state.loading} scroll={{ x: this.state.totalWidth }}/>
                </Row>
            </div>
        );
    }
}
const mapStateTopProps = (state) => {
    return {
        user:state.user,
        current:state.questionManage.evaluating.current,
    };
}
const mapDispatchToProps = dispatch => {
    return {
        setCurrent:(val)=>{
            dispatch(action.setCurrent(val));
        },
    }
};

export default connect(mapStateTopProps,mapDispatchToProps)(MissionList);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/evaluating_task_list/view.js